// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st2[data-v-782f3671] {\n  fill: #fff\n}\n.st117[data-v-782f3671] {\n  fill: #eb70eb\n}\n.st118[data-v-782f3671] {\n  fill: #c52ed6\n}\n", ""]);
// Exports
module.exports = exports;
